import { useMediaQuery } from '@mantine/hooks'

/** Below Mantine's `sm` (48em, 768 px): modals go full screen (UX spec §4.5, W-50). */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 47.99em)') ?? false
}

/**
 * Below M3's compact breakpoint (600 px, §9.1): the bottom nav bar and FAB replace the rail (Layout.tsx, §11.3).
 * The raw string is exported too, for `router.tsx`'s view-transition direction, which runs outside React and
 * cannot call this hook — both read the one literal, so they can't drift apart.
 */
export const COMPACT_NAV_QUERY = '(max-width: 37.4375em)'

export function useCompactNav(): boolean {
  return useMediaQuery(COMPACT_NAV_QUERY) ?? false
}
